import { AppState } from '../reducers';

type SubstateSelector<TSubstate> = (state: AppState) => TSubstate;
type Accessor<TSubstate,TValue> = (substate: TSubstate) => TValue;

export const makeSubstateAccessorCreator = 
<TSubstate>(subStateSelector: SubstateSelector<TSubstate>) =>
    <TValue>(accessor: Accessor<TSubstate,TValue>) => 
        (state: AppState) => 
            accessor(subStateSelector(state));